// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-content {
  padding-top: 100px;
}

.banner {
  display: flex;
  justify-content: center;
  background-color: #E37383;
  padding-block: 20px;
}

.banner h3 {
  color: #ffffff;
  text-align: center;
  margin-block: 0px;
}

.main-image {
  background-size: cover;
  background-position: center;
  color: #ffffff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40em;
  max-height: 60vh;
}

.main-image-content {
  padding: 20px;
}

.main-image h1 {
  font-size: 72px;
  text-shadow: 1px 2px 4px #000000;
  margin: 0 0 20px;
  height: 100%;
}

.main-image p {
  font-size: 24px;
  margin: 0;
}

.about-section {
  padding: 20px 0px 20px 0px;
  text-align: center;
  background-color: #f0f0f0;
}

.about-logo {
  width: 250px;
  margin-bottom: 1em;
}

.about-section p {
  max-width: 50vw;
  margin: 0 auto;
  font-size: 18px;
  line-height: 1.6;
}

.initiatives-section {
  padding: 50px 20px;
  text-align: center;
}

.initiatives-section h2 {
  margin-bottom: 40px;
  font-size: 36px;
}

.initiatives-row {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.initiative-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #ffffff;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: left;
  width: 300px;
  height: 420px;
  margin: 0 10px;
}

.initiative-card img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 10px;
}

.initiative-card h3 {
  font-size: 24px;
  margin: 5px 0;
}

.initiative-card p {
  margin: 5px 0;
}

.learn-more {
  color: #6a1b9a;
  text-decoration: none;
  font-weight: bold;
}

.learn-more:hover {
  text-decoration: underline;
}

.news {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.news h2 {
  margin-bottom: 20px;
  font-size: 36px;
}

.news a {
  display: block;
  margin-bottom: 10px;
  font-size: 20px;
}

.news p {
  margin-top: 0px;
  font-size: 18px;
}

.team-section {
  background-color: #f0f0f0;
  padding: 50px 20px;
  text-align: center;
}

.team-section h2 {
  margin-bottom: 40px;
  font-size: 36px;
}

.team-row {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.team-member {
  background-color: #f0f0f0;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;
  width: 250px;
  margin: 10px;
}

.team-member img {
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 10px;
}

.team-member h3 {
  font-size: 20px;
  margin-bottom: 5px;
}

.team-member p {
  font-size: 16px;
  color: #555;
}

`, "",{"version":3,"sources":["webpack://./src/components/MainContent.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".main-content {\r\n  padding-top: 100px;\r\n}\r\n\r\n.banner {\r\n  display: flex;\r\n  justify-content: center;\r\n  background-color: #E37383;\r\n  padding-block: 20px;\r\n}\r\n\r\n.banner h3 {\r\n  color: #ffffff;\r\n  text-align: center;\r\n  margin-block: 0px;\r\n}\r\n\r\n.main-image {\r\n  background-size: cover;\r\n  background-position: center;\r\n  color: #ffffff;\r\n  text-align: center;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 40em;\r\n  max-height: 60vh;\r\n}\r\n\r\n.main-image-content {\r\n  padding: 20px;\r\n}\r\n\r\n.main-image h1 {\r\n  font-size: 72px;\r\n  text-shadow: 1px 2px 4px #000000;\r\n  margin: 0 0 20px;\r\n  height: 100%;\r\n}\r\n\r\n.main-image p {\r\n  font-size: 24px;\r\n  margin: 0;\r\n}\r\n\r\n.about-section {\r\n  padding: 20px 0px 20px 0px;\r\n  text-align: center;\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.about-logo {\r\n  width: 250px;\r\n  margin-bottom: 1em;\r\n}\r\n\r\n.about-section p {\r\n  max-width: 50vw;\r\n  margin: 0 auto;\r\n  font-size: 18px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.initiatives-section {\r\n  padding: 50px 20px;\r\n  text-align: center;\r\n}\r\n\r\n.initiatives-section h2 {\r\n  margin-bottom: 40px;\r\n  font-size: 36px;\r\n}\r\n\r\n.initiatives-row {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.initiative-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  background-color: #ffffff;\r\n  padding: 20px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  border-radius: 8px;\r\n  text-align: left;\r\n  width: 300px;\r\n  height: 420px;\r\n  margin: 0 10px;\r\n}\r\n\r\n.initiative-card img {\r\n  width: 100%;\r\n  height: 150px;\r\n  object-fit: cover;\r\n  border-radius: 8px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.initiative-card h3 {\r\n  font-size: 24px;\r\n  margin: 5px 0;\r\n}\r\n\r\n.initiative-card p {\r\n  margin: 5px 0;\r\n}\r\n\r\n.learn-more {\r\n  color: #6a1b9a;\r\n  text-decoration: none;\r\n  font-weight: bold;\r\n}\r\n\r\n.learn-more:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.news {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.news h2 {\r\n  margin-bottom: 20px;\r\n  font-size: 36px;\r\n}\r\n\r\n.news a {\r\n  display: block;\r\n  margin-bottom: 10px;\r\n  font-size: 20px;\r\n}\r\n\r\n.news p {\r\n  margin-top: 0px;\r\n  font-size: 18px;\r\n}\r\n\r\n.team-section {\r\n  background-color: #f0f0f0;\r\n  padding: 50px 20px;\r\n  text-align: center;\r\n}\r\n\r\n.team-section h2 {\r\n  margin-bottom: 40px;\r\n  font-size: 36px;\r\n}\r\n\r\n.team-row {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.team-member {\r\n  background-color: #f0f0f0;\r\n  padding: 20px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n  border-radius: 8px;\r\n  text-align: center;\r\n  width: 250px;\r\n  margin: 10px;\r\n}\r\n\r\n.team-member img {\r\n  width: 100%;\r\n  height: 300px;\r\n  object-fit: cover;\r\n  border-radius: 8px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.team-member h3 {\r\n  font-size: 20px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.team-member p {\r\n  font-size: 16px;\r\n  color: #555;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
